// Single source of truth for the version of Stoop's legal agreements that a
// user has accepted. Covers the Terms of Use, Privacy Policy, and (for sellers)
// the Founding Maker Terms as one umbrella "legal bundle" version, the way
// mainstream apps track a single terms-acceptance version per user.
//
// Date-based so it reads as a real revision date. Bump this whenever any of the
// agreements materially change; every user is then re-prompted to accept via
// the in-app legal-update gate before continuing, and the new acceptance is
// recorded (users.termsAcceptedVersion / termsAcceptedAt).
export const CURRENT_LEGAL_VERSION = "2026-07-13";

// Item categories that carry meaningful food-safety risk (perishable animal
// products and home-kitchen prepared foods). Buying any of these triggers a
// per-order assumption-of-risk acknowledgment at checkout, on top of the
// blanket acceptance in the Terms of Use. Both the client (whether to show the
// prompt) and the server (whether to require it) read this one list.
export const FOOD_RISK_CATEGORIES: readonly string[] = ["meat", "dairy", "eggs", "prepared"];

export function cartNeedsFoodRiskAck(categories: (string | null | undefined)[]): boolean {
  return categories.some((c) => FOOD_RISK_CATEGORIES.includes(c ?? ""));
}
